import React from 'react';
import { View } from 'react-native';

import Header from '@preflighttech/preflight-tables/dist/components/Header';
import Row from '@preflighttech/preflight-tables/dist/components/Row';

const minimalTable = props => {
  const {
    orderedColumns,
    dimensions,
    movableColumns,
    moveColumn,
    order,
    updateOrder,
    styles,
    entries,
  } = props;

  const headerStyles = {
    ...styles.header,
    label: { fontSize: 14 },
  };

  return (
    <View>
      <Header
        columns={orderedColumns}
        dimensions={dimensions}
        movableColumns={movableColumns}
        moveColumn={moveColumn}
        order={order}
        updateOrder={updateOrder}
        styles={headerStyles}
      />

      {
        entries.map((entry, index) => {
          return (
            <Row
              key={entry.id}
              entry={entry}
              columns={orderedColumns}
              index={index}
              dimensions={dimensions}
              styles={styles?.data}
            />
          );
        })
      }
    </View>
  );
}

export default minimalTable;
